import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'que-change-name-popup',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ReactiveFormsModule, FormsModule],
    templateUrl: './change-name-popup.component.html',
    styleUrls: ['./change-name-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeNamePopupComponent {

  name = new FormControl<string>("");
  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { name: string; index: number },
    private dialogRef: MatDialogRef<ChangeNamePopupComponent>,
  ) {
    if (data.name != "" && data.name != undefined) {
      this.name.setValue(data.name);
    }
    //  else {  this.name.setValue(`page ${data.index+1}`) }
    dialogRef.disableClose = true;
  }
  cancel() {
    this.dialogRef.close(undefined);
  }
  save() {
    this.dialogRef.close(this.name.value);
  }
}
